import React, {ReactNode} from 'react';

interface ModalContentProps {
    className?: string,
    children: ReactNode,
    style?: object,
}

/**
 * @deprecated use Dialog instead
 * @see main/symfony/src/FrontBundle/React/src/features/dialog/components/Dialog.tsx
 * @param props
 * @constructor
 */
function ModalContent({className = 'modal-dialog gb-modal-dialog', children, style}: ModalContentProps) {
    return (
        <div className="modal gb-modal fade in" style={{display: 'block'}}>
            <div
                className={className}
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-content gb-card gb-modal-content" style={style}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default ModalContent;
